import { Box } from '@mui/joy';
import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router';

import { BackendHeader } from '@/components/navigations/BackendHeader';
import { Footer } from '@/components/navigations/Footer';
import { UserGuard } from '@/modules/UserGuard';
import { UserStatus } from '@/modules/api';
import { useUserQuery } from '@/queries/useUserQuery';
import { theme } from '@/setup/theme';

function RouteComponent() {
  const { data: user, isLoading } = useUserQuery();

  const { pathname } = useLocation();

  if (isLoading) return null;

  if (!user) {
    window.location.replace(`/api/authentication/login?relayState=${encodeURIComponent(pathname)}`);

    return null;
  }

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.surface,
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {UserGuard.isUser(user) && user.status === UserStatus.ACTIVE && <BackendHeader />}

      <Outlet />

      <Footer />
    </Box>
  );
}

export const Route = createFileRoute('/_authenticated')({
  component: RouteComponent,
});
